import { cn } from '@repo/utils';
import { Button } from './Button';

type BannerVariant = 'danger' | 'warning' | 'info';

interface BannerProps {
  variant?: BannerVariant;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

const variantClasses: Record<BannerVariant, { border: string; badge: string }> = {
  danger: {
    border: 'border-l-danger-500',
    badge: 'bg-danger-bg text-danger-text',
  },
  warning: {
    border: 'border-l-warning-500',
    badge: 'bg-warning-bg text-warning-text',
  },
  info: {
    border: 'border-l-info-500',
    badge: 'bg-info-bg text-info-text',
  },
};

export function Banner({
  variant = 'danger',
  title,
  description,
  action,
  secondaryAction,
  className,
}: BannerProps) {
  const styles = variantClasses[variant];

  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-surface-1 border-l-4',
        styles.border,
        className,
      )}
    >
      <div className="flex items-start gap-3 p-4">
        <div className="flex-1 min-w-0">
          <p className={cn('text-sm font-semibold', styles.badge, 'inline-block px-2 py-0.5 rounded-sm')}>
            {title}
          </p>
          {description && (
            <p className="mt-1.5 text-xs text-text-secondary">
              {description}
            </p>
          )}
        </div>
        {(action || secondaryAction) && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {secondaryAction && (
              <Button variant="ghost" size="sm" onClick={secondaryAction.onClick}>
                {secondaryAction.label}
              </Button>
            )}
            {action && (
              <Button variant="ghost" size="sm" onClick={action.onClick}>
                {action.label}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
